import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ExcelService } from 'src/app/services/excel.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-partners',
    templateUrl: './partners.component.html',
    styleUrls: ['./partners.component.scss'],
    standalone: false
})
export class PartnersComponent implements OnInit {

  public users: [];
  public partnersUsers = [
    { partName: 'British Foundation', signUp: 'X', accountsCreated: 500, paidAccounts: 300 }
  ]
  public selectedUser: any;
  public showAllUsers: boolean;
  public userDetail: boolean;

  constructor(private router: Router, public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private excelService: ExcelService, public themeService: ThemeService) { }

  ngOnInit() {
    this.showAllUsers = true
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.users, 'Users');
  }

  onSelect(dataUser) {
    this.showAllUsers = false;
    this.selectedUser = dataUser
    this.userDetail = true
  }
  
  backFromDetailUser() {
    this.showAllUsers = true
    this.userDetail = false
  }

}
